// We don't use react-intl or any other imports to reduce the chances of failing
import './styles.css';
import { Shirt } from '#src/atoms/icons/shirts/Shirt.tsx';
import { LANDING } from '#src/constants/__generated__/routes.ts';

const levelOfErrorCode = (code: number | string) => {
  if (Number(code) >= 500) return 'error';
  if (Number(code) >= 400) return 'warning';
  return 'info';
};

const isPermanentClientError = (code: number | string) =>
  Number(code) >= 400 && Number(code) < 500 && Number(code) !== 429;

type Props = {
  message: string;
  code: number | string;
  urls?: { label: string; url: string }[];
};
export const HandledError = ({ code, message, urls }: Props) => {
  const level = levelOfErrorCode(code);

  return (
    <div className="handled-error-root">
      {/* Reloading a 404 every minute is useless; a 429 or a lost connection
          (code 'OOPS') can clear up, so those keep the retry. */}
      {!isPermanentClientError(code) && (
        <meta httpEquiv="refresh" content="60" />
      )}
      <div>
        <Shirt className={`handled-error-${level}`} size={8} />
        <h1>{code}</h1>
        <h3>{message}</h3>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '16px',
        }}
      >
        {urls?.map(url => (
          <a key={url.label} href={url.url}>
            {url.label}
          </a>
        ))}
        <a href={LANDING}>Go to homepage</a>
      </div>
    </div>
  );
};
